export default __webpack_public_path__ + "static/media/Mr. Pramod Kumar Pradhan.edec0e03.png";